import { h, Component } from 'preact';

import Store from './store';
import Player from './player';
import AdUnits from './adunits';
import Pixel from './pixel';
import { config, constants, links, setDomain } from './config';
import * as Helper from './helper';

const Linear = require('./linearAds/linear');
const HEAD = document.getElementsByTagName('head')[0];

export default class App extends Component {
  constructor(props) {
    super(props);

    let urlParams = Helper.getUrlParams(window.location.href);
    this.state = {
      editorMode: urlParams.editorMode === 'true' ? true : false,
      projectScriptMode: urlParams.projectScript === '1',
      expand: false,
      fbContainerHeightOffsetTop: 0,
      fbContainerHeightOffsetBottom: 0,
      id: null,
      isAd: false,
      isFacebookAd: urlParams.fbAd === '1',
      isFacebookApp: false,
      isMobileDevice: false,
      isPluggedIn: this.props.pluggedIn,
      json: null,
      loader:
        urlParams.nologo === '1' || urlParams.editorMode === 'true'
          ? false
          : true,
      orientation: null,
      os: Helper.getMobileOS(),
      ready: false,
      showDebugConsole: false,
      noBranding: false,
      projectVideoId: null,
      displayDirectTag: this.props.displayDirectTag,
      viewer_id: '',
      macroParams: {},
      personalizeMsg: null,
    };
    this.network = null; // ad network to be sent in event log calls---
    this.tid = null;
    this.componentShouldBind();
  }

  componentWillMount() {
    let self = this;

    this.loadFontsPromise = Helper.loadCSS(links.fontpath, HEAD);
    this.loadTypeFacePromise = Helper.loadCSS(links.typeface, HEAD);
    this.store = new Store();

    if (
      this.props.type === 'MRAID' ||
      window.location.host.indexOf('wootag') !== -1 ||
      window.location.host.indexOf('unlead') !== -1 ||
      window.location.host.indexOf('localhost') !== -1 ||
      window.location.host.indexOf('192.168') !== -1 ||
      this.props.forceStart
    ) {
      this.start();
    }

    window.getVPAIDAd = function () {
      window.vpaid = new VpaidAd(self);
      return window.vpaid;
    };
  }

  componentDidMount() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    window.addEventListener('resize', this.handleOrientationChange);
    window.addEventListener('message', this.handlePostMessage);

    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 500);

    if (this.props.displayDirectTag) {
      const url = new URL(document.currentScript.src);
      const currentDomain = url && url.origin;
      const release_version =
        url && url.searchParams && url.searchParams.get('v');
      if (currentDomain) {
        Helper.loadCSS(Helper.getCSSPath(currentDomain, release_version), HEAD);
      }
    }
    this.isUnlead = window.location.host.indexOf('unlead') !== -1;
  }

  componentWillUnmount() {
    window.removeEventListener(
      'orientationchange',
      this.handleOrientationChange
    );
    window.removeEventListener('resize', this.handleOrientationChange);
    window.removeEventListener('message', this.handlePostMessage);
  }

  componentShouldBind() {
    this.setJSON = this.setJSON.bind(this);
    this.handleOrientationChange = this.handleOrientationChange.bind(this);
    this.removeLoader = this.removeLoader.bind(this);
    this.forceDesktopEmulation = this.forceDesktopEmulation.bind(this);
    this.forceMobileEmulation = this.forceMobileEmulation.bind(this);
  }

  render(props, state) {
    if (this.state.ready) {
      // When the player loads in DP video in video mode we need to hide the close buttons on child player tags---
      const parentEle =
        window.frameElement && window.frameElement.parentElement;
      const isPassivePlayer =
        parentEle && parentEle.classList.contains('iframeVideoContainer');
      //---
      let orientation = Helper.getOrientation();
      let minHeight = Helper.getMinHeight();
      let templateLayout =
        window.innerHeight < minHeight &&
        window.innerWidth < window.innerHeight &&
        //  this.state.isMobileDevice &&
        orientation === constants.ORIENTATION_LANDSCAPE
          ? 3
          : window.innerHeight > 720
          ? 1
          : 2;

      let isMobile = state.isMobileDevice ? 'mobile' : 'desktop';
      let network = this.state.network ? this.state.network.toLowerCase() : '';
      let klass = `${isMobile} ${network} ${orientation} template_${templateLayout} ${
        isPassivePlayer ? 'isPassivePlayer' : ''
      }`;
      let containerHeight = state.isFacebookApp
        ? document.clientHeight
        : '100%';

      const videoNotAvailable =
        props.isProject && props.type === 'MRAID' && !state.projectVideoId;
      const videoNotAvailableByGeo =
        !state.isAd && state.json && state.json.geo_video_restriction;
      const viewsExhaustedBgStyle =
        state.json &&
        (state.json.views_exhausted ||
          state.json.no_video_schedule ||
          videoNotAvailable ||
          videoNotAvailableByGeo)
          ? { backgroundImage: `url(${state.json.cover_src})` }
          : {};

      const isLandscape = orientation === constants.ORIENTATION_LANDSCAPE;
      const strictHeight =
        isLandscape && state.isMobileDevice
          ? { height: window.innerHeight }
          : {};
      /*
			* datajson response structure when views have exhausted---
			{
					"tags": [],
					"cover_src": "https://wootag-output-beta.s3.amazonaws.com/wootag/video/new-user/coverimages/720_0000.jpg",
					"views_exhausted": true
			}
			*/
      return (
        <div
          id="wtPlay"
          class={klass}
          // style={containerHeight}
          style={strictHeight}
        >
          {state.json &&
          (state.editorMode ||
            (!state.json.views_exhausted &&
              !state.json.no_video_schedule &&
              !videoNotAvailable &&
              !videoNotAvailableByGeo)) ? (
            <Player
              id={state.id}
              json={state.json}
              setJSON={this.setJSON}
              updateMerchantData={this.updateMerchantData}
              updateJsonTag={this.updateJsonTag}
              adType={state.adType}
              adUnitSrv={state.adUnitSrv}
              adUnits={this.adUnits}
              adUnitsArgs={state.adUnitsArgs}
              creativeData={state.creativeData}
              isMraidProject={props.isProject && props.type === 'MRAID'}
              initAd={state.initAd}
              isAd={state.isAd}
              containerHeight={containerHeight}
              fbContainerHeightOffsetTop={state.fbContainerHeightOffsetTop}
              fbContainerHeightOffsetBottom={
                state.fbContainerHeightOffsetBottom
              }
              isFacebookApp={state.isFacebookApp}
              isMobileDevice={state.isMobileDevice}
              isTabletDevice={state.isTabletDevice}
              orientation={orientation}
              os={state.os}
              forceMobileEmulation={this.forceMobileEmulation}
              forceDesktopEmulation={this.forceDesktopEmulation}
              toggleExpand={this.toggleExpand}
              removeLoader={this.removeLoader}
              logDataEvent={this.logDataEvent}
              logPollOption={this.logPollOption}
              fetchRedeemCode={this.fetchRedeemCode}
              trackEvent={this.trackEvent}
              eventBus={this.eventBus}
              network={network}
              forceStart={props.forceStart}
              displayDirectTag={
                state.displayDirectTag || props.displayDirectTag
              }
              displayImpTrackers={props.displayImpTrackers}
              displayAdClickThroughLink={props.displayAdClickThroughLink}
              macroParams={state.macroParams}
              projectScriptMode={state.projectScriptMode}
              fetchThirdPartyProductData={this.fetchThirdPartyProductData}
              personalizeMsg={state.personalizeMsg}
            />
          ) : null}

          {state.json &&
            (state.json.views_exhausted ||
              state.json.no_video_schedule ||
              videoNotAvailable ||
              videoNotAvailableByGeo) &&
            !state.editorMode && (
              <div
                className={'wtViewsExhaustedContainer'}
                style={viewsExhaustedBgStyle}
              >
                <div className={'wtMessage'}>
                  <i class="zmdi zmdi-alert-triangle" />
                  <p>Sorry, this video is currently not available</p>
                </div>
              </div>
            )}

          {!this.isUnlead && state.noBranding && !state.isAd && (
            <div
              className={`wtBrandingLogo`}
            />
          )}
          {state.loader &&
          !state.json.views_exhausted &&
          !state.json.no_video_schedule &&
          !videoNotAvailable &&
          !videoNotAvailableByGeo &&
          !state.projectScriptMode &&
          (!state.isAd ||
            (state.isAd &&
              constants.NO_LOADER_NETWORKS.every(
                (nw) => nw.toLowerCase() !== network
              ))) ? (
            <div class={`apploader ${this.isUnlead ? 'unlead' : ''}`}>
              <div class="loader" />
            </div>
          ) : null}

          {state.showDebugConsole ? (
            <div class={'debugConsole'}>
              {/* <h3>Debug Console</h3> */}
              <div class={'debug-info'}>
                <p>{`window.innerHeight: ${window.innerHeight}`}</p>
                <p>{`window.innerWidth: ${window.innerWidth}`}</p>
                <p>{`document.body.clientHeight: ${document.body.clientHeight}`}</p>
                {/* <p>{`navigator.userAgent: ${navigator.userAgent}`}</p> */}
                {/* <p>{`isFacebookApp: ${state.isFacebookApp}`}</p> */}
              </div>
            </div>
          ) : null}
          {!this.state.viewer_id && <Pixel />}
        </div>
      );
    } else return null;
  }

  start(creativeData) {
    let init;
    let isAd = false;
    let mraidProjectVideoFetch;
    if (typeof creativeData !== 'undefined' || this.props.type === 'MRAID') {
      isAd = true;

      if (this.props.type === 'MRAID') {
        // extracting the network name & tid from the mraid data---
        const networkData = this.props.networkData;
        if (networkData) {
          let temp = networkData.split("'").join('');
          temp = temp.split(';');
          let network = temp.find((item) => item.indexOf('network:') !== -1);
          network = network.split(':')[1];
          if (network) {
            this.network = network;
          }
          let tid = temp.find((item) => item.indexOf('tid:') !== -1);
          tid = tid.split(':')[1];
          if (tid) {
            this.tid = tid;
          }
        }

        // to fetch the videoId in case of project for MRAID ad---
        if (this.props.isProject) {
          mraidProjectVideoFetch = new Promise((resolve, reject) => {
            this.store
              .fetchProjectVideoId(
                this.props.videoString,
                this.props.mraidTarget
              )
              .then((res) => {
                let projectVideoId = res.data && res.data.guid;

                if (projectVideoId && projectVideoId.length === 16) {
                  this.setState({ projectVideoId }, () => {
                    const projectVideoString = `${this.props.videoString.substr(
                      0,
                      16
                    )}${this.state.projectVideoId}`;
                    init = this.store
                      .initializeAd(
                        null,
                        projectVideoString,
                        this.props.mraidTarget,
                        'MRAID',
                        { network: this.network, tid: this.tid }
                      )
                      .then((resInit, rejInit) => {
                        resolve(resInit);
                      });
                  });
                } else {
                  // mraid dummy data when no project video schedule is available, in that case videoid can't be fetched so no datajson is called---
                  const dummyData = {
                    json: {
                      tags: [],
                      trackers: [],
                    },
                    id: 0,
                  };

                  resolve(dummyData);
                }
              });
          }).catch((err) => {
            console.log('error fetching project video id', err);
          });
        } else {
          init = this.store.initializeAd(
            null,
            this.props.videoString,
            this.props.mraidTarget,
            'MRAID',
            { network: this.network, tid: this.tid }
          );
        }

        this.loadCSSPromise = Helper.loadCSS(
          Helper.getCSSPath(this.props.mraidTarget),
          HEAD
        );
      } else {
        try {
          creativeData = JSON.parse(creativeData);
        } catch (e) {}

        const network = creativeData && creativeData.network;
        if (network) {
          this.network = network;
        }
        const tid = creativeData && creativeData.tid;
        if (tid) {
          this.tid = tid;
        }

        const release_version = creativeData && creativeData.release_version;

        let currentDomain =
          creativeData &&
          creativeData.srv &&
          Helper.trimLastSlash(creativeData.srv);
        let staticDomain =
          creativeData &&
          creativeData.static &&
          Helper.trimLastSlash(creativeData.static);
        setDomain(currentDomain);
        init = this.store.initializeAd(creativeData, null, null, 'VPAID', {
          network: this.network,
          tid: this.tid,
        });
        const cssDomain = staticDomain || currentDomain;
        this.loadCSSPromise = Helper.loadCSS(
          Helper.getCSSPath(cssDomain, release_version),
          HEAD
        );
      }
    } else {
      if (this.state.isPluggedIn) {
        const videoId = this.state.projectVideoId || this.props.videoId;
        init = this.store.initialize(
          this.props.bucketId,
          videoId,
          this.props.json,
          this.props.forceStart
        );
      } else {
        init = this.store.initialize();
      }
    }

    this.loadCSSPromise =
      config.env === constants.ENV_DEV
        ? this.emptyPromise
        : this.loadCSSPromise;

    Promise.all([
      init,
      this.loadCSSPromise,
      this.loadTypeFacePromise,
      mraidProjectVideoFetch,
    ]).then((res) => {
      // console.log('promiseAll res', res);
      const response = this.props.isProject ? res[3] : res[0];

      this.logDataEvent = this.state.editorMode
        ? this.noop
        : this.store.logDataEvent.bind(this.store);
      this.logPollOption = this.state.editorMode
        ? this.noop
        : this.store.logPollOption.bind(this.store);
      this.fetchRedeemCode = this.state.editorMode
        ? this.noop
        : this.store.fetchRedeemCode.bind(this.store);
      this.eventBus = this.state.editorMode
        ? this.noop
        : this.store.eventBus.bind(this.store);

      this.setTrackers = this.state.editorMode
        ? this.noop
        : this.store.setTrackers(response.json.trackers);
      this.trackEvent = this.state.editorMode
        ? this.noop
        : this.store.trackEvent.bind(
            this.store,
            this.setTrackers,
            this.logDataEvent
          );
      this.fetchThirdPartyProductData = this.state.editorMode
        ? this.emptyPromise
        : this.store.fetchThirdPartyProductData.bind(this.store);
      /**
       * Rules based interactivity---
       */
      if (response.json.active_rules) {
        const allRuleCurrValue = response.json.active_rules.all || {};
        // Weather rules---
        const customEvents = response.json.live && response.json.live.events;
        const weatherData =
          customEvents && customEvents.find((evt) => evt.type === 'weather');
        const weatherRules = (weatherData && weatherData.rules) || [];
        let activeWeatherRules = response.json.active_rules.weather || [];
        const activeWeatherRuleValue = allRuleCurrValue.weather || [];
        activeWeatherRules = activeWeatherRules.map((r) => {
          const ruleId = r.rule_id;
          const ruleValue = activeWeatherRuleValue.find((v) => v.id === ruleId);
          let currValue = ruleValue && ruleValue.value;
          if (currValue && String(currValue).includes('_precip_')) {
            currValue = Number(currValue.split('_precip_')[1]) * 100;
            currValue = currValue.toFixed(1);
          }
          return {
            ...r,
            currValue: { val: currValue, id: ruleId },
          };
        });
        // Football rules---
        const footballData =
          customEvents && customEvents.find((evt) => evt.type === 'football');
        const footballRules = (footballData && footballData.rules) || [];
        const activeFootballRules = response.json.active_rules.football || [];

        // Cricket rules---
        const cricketData =
          customEvents && customEvents.find((evt) => evt.type === 'cricket');
        const cricketRules = (cricketData && cricketData.rules) || [];
        const activecricketRules = response.json.active_rules.cricket || [];
        const cricketDefaultTagids =
          (cricketData && cricketData.default_tagids) || [];

        // Forex rules---
        const forexData =
          customEvents && customEvents.find((evt) => evt.type === 'forex');
        const forexRules = (forexData && forexData.rules) || [];
        const activeforexRules = response.json.active_rules.forex || [];

        // Stock rules---
        const stockData =
          customEvents && customEvents.find((evt) => evt.type === 'stock');
        const stockRules = (stockData && stockData.rules) || [];
        const activestockRules = response.json.active_rules.stock || [];

        // Crypto rules---
        const cryptoData =
          customEvents && customEvents.find((evt) => evt.type === 'crypto');
        const cryptoRules = (cryptoData && cryptoData.rules) || [];
        const activecryptoRules = response.json.active_rules.crypto || [];

        // mapping each tagid in active rule to its current value---
        const activeTagidValueMapping = {};

        if (
          weatherRules.some((r) => r.tagids) ||
          footballRules.some((r) => r.tagids) ||
          cricketRules.some((r) => r.tagids) ||
          forexRules.some((r) => r.tagids) ||
          stockRules.some((r) => r.tagids) ||
          cryptoRules.some((r) => r.tagids)
        ) {
          activeWeatherRules.forEach((rule) => {
            const tags = rule.tagids || [];
            tags.forEach((tag) => {
              const current = activeTagidValueMapping[tag] || [];
              activeTagidValueMapping[tag] = [...current, rule.currValue];
            });
          });
          let tagids = []
            .concat(
              ...activeWeatherRules.map((rule) => {
                const tags = rule.tagids || [];
                return tags;
              })
            )
            .concat(
              ...activeFootballRules.map((rule) => {
                const tags = rule.tagids || [];
                return tags;
              })
            )
            .concat(
              ...activecricketRules.map((rule) => {
                const tags = rule.tagids || [];
                return tags;
              })
            )
            .concat(
              ...activeforexRules.map((rule) => {
                const tags = rule.tagids || [];
                return tags;
              })
            )
            .concat(
              ...activestockRules.map((rule) => {
                const tags = rule.tagids || [];
                return tags;
              })
            )
            .concat(
              ...activecryptoRules.map((rule) => {
                const tags = rule.tagids || [];
                return tags;
              })
            );
          /**
           * will need to concat default tagids later on when they will be available for all signals..
           * for now only cricket has default_tagids.
           * */
          tagids = tagids.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
          if (tagids.length === 0) {
            tagids = cricketDefaultTagids;
          }
          response.json.tags = response.json.tags
            .filter((t) => tagids.includes(t.id))
            .map((t) => ({
              ...t,
              activeSignalRuleValue: activeTagidValueMapping[t.id],
            }));
        }
        // For Display Ads if any rule is active the first active tag is set as display tag
        if (this.props.displayDirectTag && response.json.tags.length > 0) {
          this.updateState({ displayDirectTag: response.json.tags[0].id });
        }
      }
      const allInitialTags = response.json.tags;
      // Check if age gate is there in json---
      response.json = Helper.filterAgeGate(response.json);

      response.json.tags = this.initTags(
        response.json.tags,
        response.json.meta
      );

      /**
       * Hotspot skin rules---
       */
      const customSkinData =
        response.json.custom && response.json.custom.customskin;
      const customSkinDataEnabled = customSkinData && customSkinData.enableSkin;
      const customSkinTagsData =
        (customSkinDataEnabled && customSkinData.tagsAttribute) || [];
      if (customSkinTagsData.length > 0) {
        customSkinTagsData.forEach((item) => {
          if (item.hotspots && item.hotspots.length > 0) {
            item.hotspots.forEach((ht) => {
              if (ht.tagId) {
                // skip this tag id
                response.json.tags = response.json.tags.filter(
                  (t) => t.id != ht.tagId
                );
              }
            });
          }
        });
      }

      /**
       * Progress Bar connected tag---
       */
      const abConfig =
        response.json.config_data_json &&
        response.json.config_data_json.abConfig;
      if (
        abConfig &&
        abConfig.enableProgressBarImage &&
        abConfig.pbTagConnected
      ) {
        response.json.tags = response.json.tags.filter(
          (t) => t.id != abConfig.pbConnectedTagId
        );
      }
      response.json.meta = response.json.meta || {};
      // response.json.meta.skin_version = 'v3';
      // response.json.meta.skin_launch = 0;

      response.json.custom = response.json.custom || {};

      const branding = response.branding;
      const enabled = branding && branding.enabled;
      const expiry = branding && branding.expiry;
      const timeNow = Date.now();
      const expiryToTimestamp =
        expiry && expiry !== -1 && new Date(expiry).getTime();
      const brandingExpired =
        expiryToTimestamp && timeNow - expiryToTimestamp > 0;
      const noBranding = enabled === 0 || brandingExpired ? true : false;
      const customCss =
        response.json &&
        response.json.config_data_json &&
        response.json.config_data_json.customCss;
      if (customCss) {
        Helper.addCustomCssNode(customCss);
      }

      // Video Impression Trackers---
      let videoImpTrackers =
        (response.json &&
          response.json.config_data_json &&
          response.json.config_data_json.impTracker) ||
        '';
      videoImpTrackers = videoImpTrackers.split('||');
      if (videoImpTrackers.length > 0) {
        videoImpTrackers.forEach((tracker) => {
          if (tracker) {
            Helper.addPixelImage(tracker);
          }
        });
      }
      //---------------------------
      this.setState(
        {
          adType: this.props.type === 'MRAID' ? 'mraid' : 'vpaid',
          adUnitSrv: response.adUnit && response.adUnit.srv,
          creativeData,

          id: response.id,
          isAd,
          isFacebookApp: response.isFacebookApp,
          isMobileDevice: response.isMobileDevice,
          isTabletDevice: response.isTabletDevice,
          orientation: response.orientation,
          json: response.json,
          network: this.network,
          noBranding,
          ready: true,
          allInitialTags,
        },
        () => {
          this.logUniqueView();
        }
      );
    });
    /** TTDMACROS
     * For Display Ads meta wootag:macro_tracker has the tracker url with macro placeholders which the
     * ad network updates while serving the ad
     * For Vpaid Ads the tracker url is in the AdParameters > macro_tracker key
     * Once we have that url with updated parameters we extract out those parameters and pass it by key name
     * to the desired trackers.
     * Currently implemented on Contest/Survey Answer clicks only...
     */
    let macroParams = this.props.macroParams;

    if (isAd && creativeData) {
      macroParams =
        creativeData.macro_tracker &&
        Helper.getUrlParams(creativeData.macro_tracker);
    }
    this.setState({ macroParams }, () => {
      this.store.setThirdParyTrackerData(macroParams);
    });

    if (!isAd) {
      const urlParams = Helper.getUrlParams(window.location.href);
      const showPersonalizeMsg = urlParams.wt_name && urlParams.wt_name !== '[RECIPIENT]';
      const templateId = urlParams.hstid || '1';
      if (showPersonalizeMsg) {
        if (urlParams.wt_name === '[RECIPIENT]') {
          urlParams.wt_name = '';
        }
        if (urlParams.wt_org === '[RECIPIENT_ORGANIZATION]') {
          urlParams.wt_org = '';
        };
        Helper.fetchPersonalizeJson().then((json) => {
          // console.log({ json });
          const template = json && json.templates && json.templates[templateId];
          const animations = json && json.animations;
          const animation = template && template.animation;
          const defaultAnimation = animations.find(
            (a) => a.type === animation.type
          );
          const animationData = { ...defaultAnimation, ...animation };
          const theme = template && template.theme;
          const keywords = (template && template.keywords) || [];
          const keywordMap = {};
          keywords.forEach((k) => (keywordMap[k] = urlParams[k]));
          let tagline = (template && template.tagline) || '';
          
          keywords.forEach((k) => {
            if (keywordMap[k]) {
              tagline = tagline.replace(`{{${k}}}`, keywordMap[k]);
              tagline = tagline.replaceAll(`[[${k}]]`, '');
            } else {
              // remove everything between `[[${k}]]` && `[[${k}]]`
              const reg = new RegExp(`\\[\\[${k}\\]\\].*\\[\\[${k}\\]\\]`, 'g');
              tagline = tagline.replace(reg, '');
            }
          });
          this.setState({
            personalizeMsg: tagline ? { tagline, style: theme, animation: animationData } : null,
          });
        });
      }
    }
  }

  initTags = (proptags, meta) => {
    let jsontags = proptags;
    /**
     * BLS
     */
    const blsTagId = meta && meta.bls && meta.bls.tag;
    if (blsTagId) {
      const blsActive = meta && meta.bls && meta.bls.show;
      jsontags = proptags.filter((t) =>
        blsActive ? blsTagId === t.id : blsTagId !== t.id
      );
      if (!blsActive) {
        meta = { ...meta, direct_tag_id: null };
      }
    }

    let tags = jsontags && JSON.parse(JSON.stringify(jsontags));
    let decisionPoints =
      tags && tags.filter((item) => item.settings.category === 15);
    const decisionPointIds = decisionPoints && decisionPoints.map((t) => t.id);
    let connectedTags = [].concat(
      ...decisionPoints.map((dp) =>
        dp.details.engagements[0].meta.map((metaItem) => metaItem.tag)
      )
    );
    // connectedTags = connectedTags.filter(t => !decisionPointIds.includes(t));
    let contests =
      tags &&
      tags.filter(
        (item) =>
          item.settings.category === 9 &&
          item.settings.subcategory &&
          item.settings.subcategory[0] &&
          item.settings.subcategory[0].type === 906
      );
    let contestLinkedTags = [].concat(
      ...contests.map((item) => item.details.engagements[0].externalLink)
    );
    let contestAnswerLinkedTags = [].concat(
      ...contests.map((item) => {
        const qObjects = JSON.parse(item.details.engagements[0].attr);
        return [].concat(
          ...qObjects.map((o) => {
            return o.answers.map((answer) => answer.linkedTag);
          })
        );
      })
    );
    contestAnswerLinkedTags = contestAnswerLinkedTags.filter(
      (item) => typeof item !== 'undefined'
    );

    let leadGenTags =
      tags &&
      tags.filter(
        (item) =>
          item.settings.category === 9 &&
          item.settings.subcategory &&
          item.settings.subcategory[0] &&
          item.settings.subcategory[0].type === 902 &&
          item.details.engagements[0].linkedTag
      );
    let leadGenLinkedTags = [].concat(
      ...leadGenTags.map((item) => item.details.engagements[0].linkedTag)
    );

    let prod360 =
      tags &&
      tags.filter(
        (item) =>
          item.settings.category === 1 &&
          item.settings.subcategory &&
          item.settings.subcategory[0] &&
          item.settings.subcategory[0].type === 106 &&
          item.details.description
      );
    let prod360LinkedTags = [].concat(
      ...prod360.map((item) => {
        const linkedTags = item.details.linkedTags || [];
        return linkedTags.length > 0 ? linkedTags : [];
      })
    );

    for (var i = tags.length - 1; i >= 0; i--) {
      let tag = tags[i];
      let subcat = tag.settings.subcategory && tag.settings.subcategory[0];
      let subtype = subcat && subcat.type;
      // Attaching json meta hotspot tag preview value to tag---
      const hotspotTagPreview = meta && meta.tagpreview_hotspot;
      const targetTagDatajsonHotspotPosition =
        tag.details &&
        tag.details.config_data_json &&
        tag.details.config_data_json.hotspotEnabled &&
        tag.details.config_data_json.hotspotPosition;
      if (hotspotTagPreview && hotspotTagPreview.length) {
        let targetTag = hotspotTagPreview.find((t) => t.id === tag.id);
        if (!targetTag && targetTagDatajsonHotspotPosition) {
          targetTag = { position: targetTagDatajsonHotspotPosition };
        }
        if (targetTag) {
          tags[i] = { ...tag, tagpreview_hotspot_position: targetTag.position };
        }
      } else if (targetTagDatajsonHotspotPosition) {
        tags[i] = {
          ...tag,
          tagpreview_hotspot_position: targetTagDatajsonHotspotPosition,
        };
      }

      if (decisionPoints && decisionPoints.length) {
        let index = tags[i] && connectedTags.indexOf(tags[i].id);

        if ((index !== undefined && index !== -1) || subtype === 1402) {
          tags.splice(i, 1);
        }
      } else if (subtype === 1402) {
        tags.splice(i, 1);
      } else if (tag.tag_completion && !tag.tag_completion.status) {
        tags.splice(i, 1);
      }
      if (contests && contests.length) {
        let index = tags[i] && contestLinkedTags.indexOf(tags[i].id);
        let answerIndex =
          tags[i] && contestAnswerLinkedTags.indexOf(tags[i].id);

        if (
          (index !== undefined && index !== -1) ||
          answerIndex !== -1 ||
          subtype === 1402
        ) {
          tags.splice(i, 1);
        }
      }
      if (leadGenTags && leadGenTags.length) {
        let index = tags[i] && leadGenLinkedTags.indexOf(tags[i].id);

        if ((index !== undefined && index !== -1) || subtype === 1402) {
          tags.splice(i, 1);
        }
      }
      if (prod360 && prod360.length) {
        let index = tags[i] && prod360LinkedTags.indexOf(tags[i].id);

        if ((index !== undefined && index !== -1) || subtype === 1402) {
          tags.splice(i, 1);
        }
      }
    }
    return tags;
  };

  handlePostMessage = (message) => {
    if (message && message.origin.includes('wootag')) {
      const data =
        (message.data &&
          typeof message.data === 'string' &&
          JSON.parse(message.data)) ||
        {};
      if (data.viewer_id) {
        this.store.setId(data.viewer_id);
        this.setState({ viewer_id: data.viewer_id });
      }
    }
  };

  updateMerchantData = (selectedMerchant, tag) => {
    const updatedTag = Helper.updateTagProductPrice(selectedMerchant, tag);
    this.updateJsonTag(updatedTag);
  };

  updateJsonTag = (updatedTag) => {
    // const json = this.state.json;

    const updatedTags = this.state.allInitialTags.map((t) => {
      if (t.id === updatedTag.id) {
        return updatedTag;
      }
      return t;
    });

    const json = Helper.filterAgeGate({
      ...this.state.json,
      tags: updatedTags,
    });
    json.tags = this.initTags(json.tags, json.meta);
    this.setState({ json }, () => {
      this.forceUpdate();
    });
  };

  toggleExpand = (expand) => {
    this.setState({
      expand,
    });
  };

  logUniqueView() {
    this.logDataEvent({
      type: 'unique_access',
      sub_type: null,
      event: 'unique_access',
      event_type: null,
    });
  }

  setJSON(data) {
    this.store.setTags(data).then((json) => {
      json.tags = this.filterHotspotTagPreview(json);
      if (this.state.editorMode) {
        json.otags = json.tags;
      }

      this.setState(
        {
          json,
        },
        () => {
          this.forceUpdate();
        }
      );
    });
  }

  filterHotspotTagPreview = (json) => {
    let tags = json.tags;
    let meta = json.meta || {};
    for (let i = tags.length - 1; i >= 0; i--) {
      let tag = tags[i];
      // Attaching json meta hotspot tag preview value to tag---
      const hotspotTagPreview = meta && meta.tagpreview_hotspot;
      const targetTagDatajsonHotspotPosition =
        tag.details &&
        tag.details.config_data_json &&
        tag.details.config_data_json.hotspotEnabled &&
        tag.details.config_data_json.hotspotPosition;
      if (hotspotTagPreview && hotspotTagPreview.length) {
        let targetTag = hotspotTagPreview.find((t) => t.id === tag.id);
        if (!targetTag && targetTagDatajsonHotspotPosition) {
          targetTag = { position: targetTagDatajsonHotspotPosition };
        }
        if (targetTag) {
          tags[i] = { ...tag, tagpreview_hotspot_position: targetTag.position };
        }
      } else if (targetTagDatajsonHotspotPosition) {
        tags[i] = {
          ...tag,
          tagpreview_hotspot_position: targetTagDatajsonHotspotPosition,
        };
      }
    }
    return tags;
  };

  handleOrientationChange(e) {
    if (
      (!window.keyboardOpen || e.type === 'orientationchange') &&
      !this.state.isFacebookAd
    ) {
      setTimeout(() => {
        this.setState({
          orientation: Helper.getOrientation(this.state.orientation),
          loader: true,
        });
      }, 100);
      setTimeout(() => {
        if (this.state.loader) {
          this.setState(
            {
              loader: false,
            },
            () => {
              document.body.scrollTop = 0;
            }
          );
        }
      }, 1000);
    }
  }

  removeLoader() {
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 100);
  }

  forceMobileEmulation() {
    this.setState({
      isMobileDevice: true,
      // orientation: 'portrait'
    });
  }

  forceDesktopEmulation() {
    this.setState({
      isMobileDevice: false,
    });
  }

  noop() {
    return;
  }

  updateState = (updates = {}) => {
    this.setState({ ...updates }, () => {
      // console.log(updates);
    });
  };

  emptyPromise() {
    return new Promise((resolve) => resolve);
  }
}

class VpaidAd extends Linear {
  constructor(props) {
    super();
    this.app = props;
  }

  fixIframe = () => {
    // wrapper iframe hacks, when our player loads inside a wrapper---
    const selfIframe = window.frameElement;
    // console.log('selfIframe>>>', selfIframe);

    if (selfIframe) {
      selfIframe.setAttribute(
        'style',
        'display:block; position:absolute; top:0; left:0; z-index:100; width: 1px; min-width: 100%; height: 1px; min-height: 100%; border: 0 none;'
      );
      // for double click there is an element just before the iframe which has width and height defined and has absolute position--
      // since the parent div of these two is also positioned absolute with no width/height defined we just update the position of prev div to relative so it loads below our iframe and sets the width/height of parent---

      var prevSibling = selfIframe.previousElementSibling;

      while (prevSibling) {
        if (prevSibling.style.position == 'absolute') {
          prevSibling.style.cssText = 'position: relative !important;';
        }

        prevSibling = prevSibling.previousElementSibling;
      }
    }
    //---
  };

  initAd(
    width,
    height,
    viewMode,
    desiredBitrate,
    creativeData,
    environmentVars
  ) {
    this.app.start(creativeData.AdParameters);
    this.app.adUnits = new AdUnits();
    this.app.setState({
      adUnitsInit: true,
      adUnitsArgs: arguments,
      initAd: super.initAd,
    });

    this.fixIframe();
  }
}



// WEBPACK FOOTER //
// ./components/app.js